// extracted by mini-css-extract-plugin
export var active = "_gi-7";
export var blink = "_gi-8";
export var dropDownSelector = "_gi-4";
export var dropDownWrapper = "_gi-3";
export var fakeCursor = "_gi-6";
export var fontSizeButton = "_gi-9";
export var formQuillEditor = "_gi-0";
export var pressed = "_gi-a";
export var qlBlank = "_gi-1";
export var textFormattingToolbar = "_gi-2";
export var textToolbarOption = "_gi-5";